<template>
    <div id="appCapsule">
        <div style="height:200px; width:400px">
            <l-map ref="map" v-model:zoom="zoom" :center="[33.15459, 54.20753]">
                <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base"
                    name="OpenStreetMap"></l-tile-layer>
            </l-map>
        </div>
    </div>

</template>

<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer } from "@vue-leaflet/vue-leaflet";

export default {
    components: {
        LMap,
        LTileLayer,
    },
    data() {
        return {
            zoom: 4,
        };
    },
};
</script>

<style></style>